<template>
  <div
    v-if="showAlert && hasToggle"
    class="warning-alert"
    :class="variant ? 'warning-alert--' + variant : ''"
  >
    <svg-loader
      v-if="icon"
      :src="'/static/images/' + icon"
      class="warning-alert__icon"
    />
    <p
      v-if="alertText"
      v-html="alertText"
    />

    <p v-else>
      Depois que o pedido de insumos é enviado para análise,
      <strong>não é possível fazer alterações ou cancelar</strong>
      . Para mais informações, entre em contato com o Executivo de Vendas responsável, ou
      obtenha suporte pelo telefone
      <strong>0800-643-8100</strong>
      opção 1.
    </p>

    <img
      class="warning-alert__btn-close"
      src="/static/images/icon-close-small.svg"
      alt="fechar alerta"
      @click="closeAlert()"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WarningAlert',
  props: {
    alertText: {
      type: String,
      required: true,
    },
    itemNameInStorage: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    featureToggle: {
      type: String,
    },
    variant: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    showAlert: false,
  }),
  computed: {
    ...mapGetters(['toggle']),
    hasToggle() {
      return this.featureToggle ? this.toggle[this.featureToggle] : true
    },
  },
  mounted() {
    // if this item already in storage hide alert
    this.showAlert = localStorage.getItem(this.itemNameInStorage) ? false : true
  },
  methods: {
    closeAlert() {
      this.showAlert = false
      localStorage.setItem(this.itemNameInStorage, true)
    },
  },
}
</script>
<style lang="scss">
.warning-alert {
  background-color: #edddc3;
  padding: 18px 30px 18px 26px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  margin: 24px 0;
  position: relative;
  font-size: 13px;
  line-height: 16px;
  color: #4a4a4a;

  p {
    flex-shrink: 2;
    margin: 0;
  }

  a {
    text-decoration: underline !important;

    &:hover {
      color: #7f1953 !important;
    }
  }

  &__icon {
    margin: 0;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
      color: #7f1953;
    }
  }

  &__btn-close {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }

  &--reference-value {
    align-items: flex-start;
    background-color: rgba(255, 191, 0, 0.2);
    border-radius: 6px;
    color: #4a4a4a;
    font-family: 'Exo 2', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    padding: 16px 24px 16px 18px;

    p {
      margin: 0;
      width: 100%;
    }

    strong {
      font-weight: 700;
    }

    .warning-alert__icon {
      display: inline-flex;
      flex-shrink: 0;
      margin: 2px 12px 0 0;
      align-items: flex-start;
    }

    .warning-alert__btn-close {
      top: 10px;
      right: 10px;
    }
  }
}
</style>
